export const isProd = window.location.hostname === 'play.bettertimestories.com';
export const isBeta = window.location.hostname === 'beta.bettertimestories.com';
export const isDev = window.location.hostname === 'iks-play-web-dev.web.app';
